module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "sidebar-form largeDownlaodBtn",
    attrs: {
      "title": "Download [Printer Counters] installer latest version",
      "action": "#",
      "method": "get"
    },
    on: {
      "click": function($event) {
        return _vm.downloadClick()
      }
    }
  }, [_c('div', {
    staticClass: "input-group btnUpload",
    staticStyle: {
      "padding": "5px 10px",
      "font-size": "20px",
      "margin": "5px auto"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "22px"
    },
    attrs: {
      "src": _vm.img,
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "btnUpload",
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "180px",
      "text-align": "center",
      "color": "#000",
      "font-weight": "normal",
      "font-size": "14px",
      "margin": "5px auto"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.info) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group btnUpload",
    staticStyle: {
      "padding": "5px 10px",
      "margin": "0 auto"
    }
  }, [_c('i', {
    class: ['btnUpload', _vm.icon]
  }), _vm._v(" "), _c('span', {
    staticClass: "btnUpload",
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v(_vm._s(_vm.btnText))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-40b0578f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/downloadBtn.vue
// module id = 700
// module chunks = 0